import { IonText } from '@ionic/react';
import { ReactElement } from 'react';

const WhatIsBeacon = (): ReactElement => {
  return (
    <IonText>
      <h2>
        Beacon provides cloud-based cobot tools that help all production teams
        maximize uptime.
      </h2>
    </IonText>
  );
};

export { WhatIsBeacon };
